import { createSelector } from 'reselect';
import { serviceProvider } from './serviceProviderSelectors.js';
import { formatDate } from '../lib/dateUtilities.js';
import todoIsOverdue from '../lib/todoIsOverdue.js';
import { filters } from './filterSelectors.js';
import { todoEventsSelector, todoEventsDueTodaySelector } from './lib/todoEventsSelector.js';
import { isToday } from 'date-fns';
import { filteredUserId } from './filterSelectors.js';
import formatDatetimeTheUniverseLifeAndEverything from 'lib/formatDatetimeTheUniverseLifeAndEverything.js';

const stableArray = [];

const todosRaw = createSelector(serviceProvider, (serviceProvider) => serviceProvider.todos || stableArray);
export const todos = createSelector(todosRaw, (todos) => todos.map((n) => ({ ...n, overdue: todoIsOverdue(n) })));
export const filteredTodos = createSelector(todos, filters, (todos, filters) => {
  return todos
    .filter((n) => (!filters.todoStatusId ? true : n.todo_status === filters.todoStatusId))
    .filter((n) => (!filters.userId ? true : n.assignee_user_id === filters.userId))
    .filter((n) => (!filters.creatorUserId ? true : n.creator_user_id === filters.creatorUserId))
    .filter((n) => (!filters.todoTypeId ? true : n.todo_type === filters.todoTypeId))
    .filter((n) => (!filters.locationId ? true : n.service_location_id === filters.locationId));
});
export const todo = (todoId) => createSelector(todos, (todos) => todos.find((n) => n.id === todoId));
export const todosByIds = (ids = []) => createSelector(todos, (todos) => todos.filter((n) => ids.includes(n.id)));
export const todosOverdue = createSelector(filteredTodos, (todos) => todos.filter((n) => n.overdue));
export const todosByDate = createSelector(filteredTodos, (todos) => {
  const byDate = {};
  todos.forEach((n) => {
    let key;
    if (String(n.target_datetime).includes(':42')) {
      const { month, day, year } = formatDatetimeTheUniverseLifeAndEverything(n.target_datetime, { json: true });
      key = `${year}-${month}-${day}`;
    } else {
      key = formatDate(n.target_datetime, 'yyyy-MM-dd');
    }

    byDate[key] = byDate[key] || [];
    byDate[key].push(n.id);
  });
  return byDate;
});
export const todoEvents = todoEventsSelector;
export const todoEventsDueToday = todoEventsDueTodaySelector;

export const notificationSidebarOverdueTodos = createSelector(todosRaw, filteredUserId, (todos, filteredUserId) => {
  return todos
    .map((n) => ({ ...n, overdue: todoIsOverdue(n) }))
    .filter((n) => n.overdue)
    .filter((n) => (filteredUserId ? n.assignee_user_id === filteredUserId || n.creator_user_id === filteredUserId : n));
});

export const notificationSidebarTodosDueToday = createSelector(todos, filteredUserId, (todos, filteredUserId) => {
  return todos
    .filter((n) => isToday(new Date(n.target_datetime)))
    .filter((n) => (filteredUserId ? n.assignee_user_id === filteredUserId || n.creator_user_id === filteredUserId : n))
    .filter((n) => n.todo_status !== '2');
});
